// An interview starts when a job's status changes to Interviewing; there is no
// separate "log interview" action, so the empty tab says how to start one.
export const INTERVIEWING_EMPTY_DESCRIPTION =
  'To start an interview, open an application and change its status to Interviewing.'

/** Empty-tab description: the Interviewing tab explains how to start an interview; others keep `fallback`. */
export function emptyTabDescription(tab: string, fallback: string): string {
  return tab === 'interviewing' ? INTERVIEWING_EMPTY_DESCRIPTION : fallback
}
